import React, { Component } from 'react';
import './Input.scss';

class Input extends Component {
    constructor(props) {
        super(props);
        this.state = {
            togglerState: this.props.togglerState ? this.props.togglerState : false
        }
    }

    render() {
        const {togglerState, toggleClicked, ...newProps} = this.props;
        if(newProps && this.state.togglerState) {
            return (
                <input
                    className={this.props.className ? this.props.className : ''}
                    type = {this.props.type ? this.props.type : ''}
                    placeholder = {this.props.placeholder ? this.props.placeholder : ''}
                    defaultChecked
                    onClick = {(e)=>{
                        if(this.props.type === 'checkbox' || this.props.type === 'radio'){
                        this.setState({togglerState: !this.state.togglerState});
                        this.props.toggleClicked(e)}}}
                    {...newProps}
                />
            );
        } else {
            return (
                <input
                    className={this.props.className ? this.props.className : ''}
                    type = {this.props.type ? this.props.type : ''}
                    placeholder = {this.props.placeholder ? this.props.placeholder : ''}
                    onClick = {(e)=>{
                            if(this.props.type === 'checkbox' || this.props.type === 'radio'){
                                this.setState({togglerState: !this.state.togglerState})
                                this.props.toggleClicked(e)
                            }
                        }
                    }
                    {...newProps}
                />
            );
        }
    }
}

export default Input;